var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsericon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7901 2.03625C16.5739 0.723125 14.8751 0 13.0001 0C11.1151 0 9.41074 0.71875 8.20011 2.02375C6.97636 3.34312 6.38011 5.13625 6.52011 7.0725C6.79761 10.8925 9.70449 14 13.0001 14C16.2957 14 19.1976 10.8931 19.4795 7.07375C19.6214 5.155 19.0214 3.36563 17.7901 2.03625ZM24.0001 28H2.00011C1.71215 28.0037 1.42698 27.9433 1.16534 27.8229C0.903702 27.7026 0.672178 27.5254 0.487613 27.3044C0.0813633 26.8188 -0.0823867 26.1556 0.0388633 25.485C0.566363 22.5588 2.21261 20.1006 4.80011 18.375C7.09886 16.8431 10.0107 16 13.0001 16C15.9895 16 18.9014 16.8438 21.2001 18.375C23.7876 20.1 25.4339 22.5581 25.9614 25.4844C26.0826 26.155 25.9189 26.8181 25.5126 27.3037C25.3281 27.5249 25.0966 27.7022 24.835 27.8226C24.5733 27.9431 24.2881 28.0037 24.0001 28Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsericon);
export default __webpack_public_path__ + "static/media/usericon.f5bde2a4781ff2e0e740e9f03f77efc3.svg";
export { ForwardRef as ReactComponent };